
'use client';

import React from 'react';
import SearchInput from './SearchInput';

interface SearchFormProps {
  query: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClear: () => void;
  onSearchClick: () => void;
  isLoading: boolean;
  registerSearchInput?: (ref: HTMLInputElement | null) => void;
}

const SearchForm: React.FC<SearchFormProps> = ({ 
  query,
  onChange,
  onKeyDown,
  onClear,
  onSearchClick,
  isLoading,
  registerSearchInput
}) => {
  return (
    <div className="relative w-full max-w-2xl">
      <SearchInput 
        className="mb-2"
        value={query}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onClear={onClear}
        onSearchClick={onSearchClick}
        isSearching={isLoading}
        registerSearchInput={registerSearchInput}
      />
    </div>
  );
};

export default SearchForm;
